import { OfferFragment } from '@occc/graphql';
import { transformCustomData } from '@occc-app/routes/CampaignComponents/components/CustomData/utils';

import { getOfferNameAndDescriptionInitialValues } from '@occc-app/routes/Offer/components/OfferConfigureForm/utils/offerNameAndDescriptionInitialValues';
import { getOfferFulfillmentPriorityInitialValues } from '@occc-app/offerHelpers/utils/getOfferFulfillmentPriorityInitialValues';
import { ConfigureFormInitialValues } from '../../../types';

const getConfigureFormInitialValues = (): ConfigureFormInitialValues => ({});

export const transformOfferToInitialValues = (
  offer?: OfferFragment,
): ConfigureFormInitialValues => {
  const values = getConfigureFormInitialValues();

  if (!offer) {
    return values;
  }

  return {
    ...values,
    ...getOfferNameAndDescriptionInitialValues(offer),
    ...getOfferFulfillmentPriorityInitialValues(offer),
    customData: transformCustomData(offer.customData),
  };
};
